import React from 'react';
import PropTypes from 'prop-types';
import { Row, Column } from '../ui/Styles';
import { Container, Title } from './Styles';

const Contact = ({ viewable }) => {
  return (
    <Container className="contact-page" viewable={viewable}>
      <Title>Contact</Title>
      <Row className="contact-page-row">
        <Column className="contact-page-col">
          <a href="tel:+447770117834">
            <span className="glyphicon glyphicon-phone-alt" />07846495307
          </a>
          <br />
          <a href="mailto:saibotlive@gmail.com?Subject=Site Feedback" target="_top">
            <span className="glyphicon glyphicon-envelope" /> saibotlive@gmail.com
          </a>
        </Column>
      </Row>
    </Container>
  );
};

Contact.propTypes = {
  viewable: PropTypes.bool.isRequired
};

export default Contact;



// WEBPACK FOOTER //
// ./src/components/ContactPage/index.js